import type { SchemaType } from '~/shared/lib/use/validation'

import { useI18n } from 'vue-i18n'

import { AuthMethod } from '~/entities/auth'
import i18n from './AuthSignupForm.i18n.json'

export function getSchema(
  method: AuthMethod,
): SchemaType<'inputValue' | 'policyFlag'>[] {
  const { t } = useI18n(i18n)
  return [
    {
      type: method,
      name: 'inputValue',
      label: method === AuthMethod.phone ? t('Телефон') : t('Эл. почта'),
      attrs: {
        'data-testid': 'auth-contact-input',
        'placeholder':
          method === AuthMethod.phone ? '+7 (999)-999-99-99' : 'user@mail.ru',
      },
      required: true,
    },
    {
      type: 'checkbox',
      name: 'policyFlag',
      label: t('Соглашение'),
      labelIsVisible: false,
      attrs: {
        'data-testid': 'auth-policy-flag-checkbox',
      },
      required: true,
    },
  ]
}
